module.exports = __webpack_public_path__ + "static/media/JohnsonsBaby-Bold.56c45d6c.ttf";